import {
  RecordGridViewServiceProvider,
  vsProviderName as RecordGridViewServiceProviderName,
} from "../../../records/views/recordGridView";
import {
  GridSettingsService,
  vsName as GridSettingsServiceName,
} from "../../../records/grids/settings/gridSettingsService";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../records/server/serverUtility";

import { RecordDataSource } from "../../../records/grids";

import {
  machineObjectName,
  machineConfigurationObjectName,
} from "../../shared/names";
import { machineConfigViewDefaultSort } from "./machineConfiguration";
import {
  ColumnDefinitionSetService,
  ColumnDefinitionSetServiceProvider,
  vsProviderName as ColumnDefinitionSetServiceProviderName,
  vsServiceName as ColumnDefinitionSetServiceName,
} from "../../../records/grids/columns/columnDefinitionSetService";

export { machineObjectName as vsObjectName };

export function machineConfig(
  recordGridViewServiceProvider: RecordGridViewServiceProvider,
  columnDefinitionSetServiceProvider: ColumnDefinitionSetServiceProvider
) {
  recordGridViewServiceProvider.addGridConfiguration(machineObjectName, [
    ServerUtilityName,
    GridSettingsServiceName,
    (
      serverUtility: ServerUtility,
      gridSettingsService: GridSettingsService
    ) => {
      return {
        columnDefinitionSet: machineObjectName,
        defaultSort: machineConfigViewDefaultSort,
        gridDataSource: new RecordDataSource(
          serverUtility,
          "/api/machines/Machine"
        ),
        gridSettings: gridSettingsService.getGridSettings(
          Symbol(machineObjectName)
        ),
        nameSingular: "Machine",
        namePlural: "Machines",
        showAddButton: true,
        showAddButtonPermission: "machineEdit",
      };
    },
  ]);

  columnDefinitionSetServiceProvider.addColumnDefinitionSet(machineObjectName, [
    ColumnDefinitionSetServiceName,
    (columnDefinitionSetService: ColumnDefinitionSetService) =>
      columnDefinitionSetService.getColumnDefinitionSet(
        machineConfigurationObjectName
      ),
  ]);
}
machineConfig.$inject = [
  RecordGridViewServiceProviderName,
  ColumnDefinitionSetServiceProviderName,
];
